import { autoinject, transient } from "aurelia-framework";
import { DialogClientService as CommonDialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { EntityValidationsService } from "../../../../../../client-validation-system/validations-service";
import { SubtasksService } from "../../../../../../services/subtasks/subtasks.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { UserClientService } from "../../../../../../services/authentication/user-client.service";
import { AddCorrespondenceDialog } from "../add-correspondence/add-correspondence-dialog";
import { PscService } from "../../../../../../services/psc/psc.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { DeficiencyDetails } from "../../../../../../models/pscs/deficiency-details";
import { AttachmentClientService } from "../../../../../../services/attachment/attachments-client.service";
import { AttachmentTypeModel } from "@rightship-tech/common-ui/models/attachments.models";
import { PartialUploadPscFiles } from "@rightship-tech/common-ui/partials/partial-upload-psc-files/partial-upload-psc-files";

@autoinject
@transient()
export class SubmitCloseOutInformationDialog extends AddCorrespondenceDialog {

    private params: any;
    showMoreText: { [key: string]: boolean } = {};
    public showAttachmentsSection: boolean = false;
    public pscDeficiencyDetails: DeficiencyDetails[] = [];
    public entityTypes= EntityTypes;
    private hasRsUserPermission = false;
    public enableNewPscUi: boolean;
    public attachmentTypes: AttachmentTypeModel[];
    public partialUploadPscFiles: PartialUploadPscFiles;

    constructor(dialogClientService: DialogClientService, commonDialogClientService: CommonDialogClientService, entityValidationsService: EntityValidationsService, subtasksService: SubtasksService,
        notificationClientService: NotificationClientService, private attachmentClientService: AttachmentClientService,
        userClientService: UserClientService, private pscService: PscService, private bindingSignaler: BindingSignaler, private userClaimsService:UserClaimsService) {
        super(dialogClientService, commonDialogClientService, entityValidationsService, subtasksService, notificationClientService, userClientService);
    }

    async onActivate(params: any): Promise<void> {
        this.params = params;        
        this.enableNewPscUi = await this.pscService.getPscSetting();

        if(this.isPSC)
        {
            if(this.enableNewPscUi){
                this.attachmentTypes = (await this.attachmentClientService.getAttachmentTypes()).filter(x => x.entityTypeId === EntityTypes.PSC);
            }

            this.getDeficiencyDetails();
        }
        this.showAttachmentsSection = true;
        this.hasRsUserPermission = this.userClaimsService.hasPermission(Claims.RightShipUser);
    }

    submitAnyway() {
        this.showWarningSection = false;
    }

    async getDeficiencyDetails() {
        const id = this.params && this.params.entityId? this.params.entityId: this.params.id;
        const result = await this.pscService.getDeficiencyDetails(id);
        this.pscDeficiencyDetails = result;
    }

    getLongText(fullText: string, key: string) {
        if (this.showMoreText && Object.keys(this.showMoreText).indexOf(key) > -1) {
            if (this.showMoreText[key])
                return fullText;
        }

        return fullText ? fullText.substring(0, 100) + (fullText.length > 100 ? '...' : '') : '';
    }

    public validateOnSubmit(): boolean {

        if(this.isPSC && this.enableNewPscUi){
            if (this.partialUploadPscFiles.otherAttachment.every(x => x.length === 0)) {
                if (!this.partialUploadPscFiles.capRcaFile || this.partialUploadPscFiles.capRcaFile?.length <= 0) {
                    this.notificationClientService.show("Close-out CAP/RCA file is required", "", NotificationType.Error);
                    return;
                }
        
                if (this.partialUploadPscFiles.aBFormsFiles.every((file) => file.length === 0)) {
                    this.notificationClientService.show("Initial PSC Report Form A/B/A+B is required", "", NotificationType.Error);
                    return;
                }
            }
    
            this.partialUploadPscFiles.mergePscFiles();
            this.files = this.partialUploadPscFiles.files;
        }

        if (this.files && this.files.filter(x => !x.attachmentTypeId).length > 0) {
            this.notificationClientService.show('', 'Attachment type is required', NotificationType.Error)
            return;
        }

        if ((!this.files || this.files.length == 0) && !this.hasRsUserPermission) {
            this.notificationClientService.show("Validation Error", "Closed out form cannot be submitted without documents", NotificationType.Error);
            return;
        }
        return true;
    }

    toggleReadMore(key: string) {
        if (!this.showMoreText)
            this.showMoreText = {};

        this.showMoreText[key] = Object.keys(this.showMoreText).indexOf(key) > -1 ? !this.showMoreText[key] : true;

        this.bindingSignaler.signal('read-more-toggled');
    }
}
